export const defaultUserCoin = {
  freeCoin: undefined,
  paidCoin: undefined,
  thirdCoin: undefined,
}
